import { useEffect, useState } from "react";
import { twJoin, twMerge } from "tailwind-merge";
import {
    ChevronLeftIcon,
    CurrencyBangladeshiIcon,
} from "@heroicons/react/24/outline";
import { getBalance } from "../../../services/counter/wallet.service";

export default function BalanceChip({ currentUser }) {
    const [showBalanceChipAnimation, setShowBalanceChipAnimation] =
        useState(true);
    const [isBalanceChipExpanded, setIsBalanceChipExpanded] = useState(false);
    const [balance, setBalance] = useState(0);
    const [isBalanceDataLoading, setIsBalanceDataLoading] = useState(false);

    const getAndSetBalance = async () => {
        if (currentUser?.config?.is_prepaid) {
            setIsBalanceDataLoading(true);
            try {
                const userBalance = await getBalance();
                if (
                    userBalance &&
                    userBalance?.data?.data?.current_balance &&
                    userBalance?.data?.data?.currency
                ) {
                    setBalance(userBalance?.data?.data);
                }
            } catch (e) {}

            setIsBalanceDataLoading(false);
        }
    };

    const onBalanceChipBtnClick = async () => {
        if (!isBalanceChipExpanded) await getAndSetBalance();
        setIsBalanceChipExpanded(!isBalanceChipExpanded);
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setShowBalanceChipAnimation(false);
        }, 3000);

        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <div className="fixed z-10" onClick={onBalanceChipBtnClick}>
            <div
                className={twMerge(
                    "flex items-center gap-x-3 absolute top-9 z-50 py-6 px-1 bg-[purple] shadow-lg rounded-tr-md rounded-br-md cursor-pointer",
                    showBalanceChipAnimation ? "animate-bounce" : "",
                    isBalanceChipExpanded ? "pr-2 py-3.5" : ""
                )}
            >
                <div className="flex gap-x-1 items-center">
                    {isBalanceChipExpanded ? (
                        <ChevronLeftIcon className="w-5 h-5 text-[yellow]" />
                    ) : (
                        <CurrencyBangladeshiIcon
                            className={twJoin(
                                "w-5 h-5 text-[yellow]",
                                isBalanceDataLoading ? "animate-spin" : ""
                            )}
                        />
                    )}
                </div>
                {isBalanceChipExpanded ? (
                    <div className="flex flex-col items-center w-max">
                        <p className="text-sm font-medium text-[yellow]">
                            Balance
                        </p>
                        <p className="text-xl font-semibold text-[yellow]">
                            {Math.round(balance?.current_balance || 0)}{" "}
                            <span className="text-sm">
                                {balance?.currency || "BDT"}
                            </span>
                        </p>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
